/**
 * Central entry for document.execCommand so rich-text behavior can be audited
 * or swapped without scattering calls through the editor.
 */
export function runExecCommand(command, showUi = false, value = null) {
  try {
    return document.execCommand(command, showUi, value);
  } catch {
    return false;
  }
}
